import styled, { css } from "styled-components";
import { motion } from "framer-motion";
import React, { InputHTMLAttributes, Ref } from "react";

interface IProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  errorMessage?: string;
  hasError?: boolean;
}

export const RadioButton = React.forwardRef(
  ({ errorMessage, hasError, label, ...props }: IProps, ref) => (
    <StyledView $checked={props.checked}>
      <label htmlFor={props.id}>
        <input {...props} type="radio" ref={ref as Ref<HTMLInputElement>} />
        {label}
      </label>
    </StyledView>
  )
);

const StyledView = styled(motion.span)<{ $checked: boolean }>`
  ${({ theme }) => css`
    display: block;

    input {
      display: none;
    }

    label {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1.6rem;
      cursor: pointer;
      font-size: 1.6rem;
      font-weight: 500;
      height: 5.2rem;
      overflow: hidden;
      transition: background-color 0.2s ease;
      position: relative;
      border: 1px solid
        ${(props) =>
          // @ts-ignore
          props.$checked
            ? theme.colors.primary_red
            : theme.colors.primary_light_gray};
      color: ${(props) =>
        // @ts-ignore
        props.$checked
          ? theme.colors.primary_red
          : theme.colors.primary_light_gray};
      border-radius: 0 1.2rem;
      background-color: ${(props) => props.theme.colors.basic_white};
    }

    label:hover {
      border-color: ${theme.colors.primary_red};
      color: ${theme.colors.primary_red};
    }
  `}
`;
